var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 1,
    y: 1.506,
    stroke: "currentColor",
    strokeWidth: 2,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.157 10.634a.5.5 0 0 1-.75-.433V6.873a.5.5 0 0 1 .75-.433l2.876 1.664a.5.5 0 0 1 0 .866z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-youtube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .506h16v16H0z"
  })))));
};
export { SvgIconYoutube as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxyZWN0IHg9IjEiIHk9IjEuNTA1ODYiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgcng9IjMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTcuMTU2NjQgMTAuNjM0MUM2LjgyMzMgMTAuODI3IDYuNDA2MjUgMTAuNTg2NCA2LjQwNjI1IDEwLjIwMTNWNi44NzI4QzYuNDA2MjUgNi40ODc3IDYuODIzMzEgNi4yNDcxNiA3LjE1NjY1IDYuNDQwMDJMMTAuMDMzMiA4LjEwNDMyQzEwLjM2NiA4LjI5Njg3IDEwLjM2NiA4Ljc3NzM1IDEwLjAzMzIgOC45Njk4OUw3LjE1NjY0IDEwLjYzNDFaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC41MDU4NTkpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";